<template>
	<div class="col-md-4">
		<div class="form-group">
			<label>{{label}}<span class="required">*</span>
    </label>
			<input type="text" class="form-control"
						 :name="name" v-only-numeric
						   v-model="value[name]" v-validate="'required'" :maxlength="length"            
						 :placeholder="placeholder" />
      <div v-show="errors.has(name)" class="help is-danger">{{ required_message }}</div>
		</div>
    
	</div>
</template>
<script>
  export default {
  name: 'DIGIT',
  inject: ['$validator'],
  props: ['placeholder', 'label', 'name', 'value','length','required_message']
  }
</script>
